import { ErrorHandler } from "UI/Errors";
import { CheckedDataRow } from "UI/UI.Controls/DataGridSubcontrols/Components/CheckedDataRow";
import { IOrderBy } from "../../../../Global/Base/DataSources/Interfaces";
import { Event } from "../../../../Global/Base/Events";
import { InvalidArgumentException } from "../../../../Global/Base/Exceptions";
import { StringUtils } from "../../../../Global/Base/Utils/StringUtils";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { Column } from "../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { ArrayMSLOVDataSource } from "../../../UI.Controls/DataSource/ArrayDataSource";
import { IDataGridSelectionChangedEvent } from "../../../UI.Controls/IEvent";
import { MSLOVCheckedGrid } from "../../UI/XGControls/Frames/MSLOVCheckedGrid";

/**
 * @internal
 */
export class MultiSelectList {
    public selectionChanged: Event<MultiSelectList, { id: string; value: boolean }> = new Event<MultiSelectList, { id: string; value: boolean }>();

    private readonly _dataGrid: MSLOVCheckedGrid;
    private readonly _dataSource: ArrayMSLOVDataSource<{}>;
    private readonly _conditionParamAttrs: string[];

    public get dataSource(): ArrayMSLOVDataSource<{}> {
        return this._dataSource;
    }

    constructor(rootElement: Element, dataSource: ArrayMSLOVDataSource<{}>, attrName: string, columns: Column[], orderBy?: IOrderBy[]) {
        this._dataGrid = rootElement.querySelector("tsc-mslovcheckeddatagrid") as MSLOVCheckedGrid;

        if (!(this._dataGrid instanceof MSLOVCheckedGrid))
            throw new InvalidArgumentException("dataGrid is not a MSLOVCheckedGrid");

        this._dataSource = dataSource;

        this._configureDataGrid(this._dataGrid, attrName, true, true, columns, orderBy);

        this._loadData();
    }

    private _configureDataGrid(dataGrid: MSLOVCheckedGrid, _attrName: string, _checkboxes: true, _preselection: true,
        columns: Column[], orderBy?: IOrderBy[]): void {
        if (orderBy)
            dataGrid.orderBy = orderBy;

        dataGrid.renderHeader = false;
        dataGrid.fetchCount = 999;

        this._dataGrid.dataSource = this._dataSource;

        try {
            this._dataGrid.columns = columns;
            const attrs = columns.map((item) => item.attrName);

            this._dataSource.setAttrs(attrs);
        } catch (err) {
            ErrorHandler.instance.handleError(err);
        }

        this._dataGrid.addEventListener("SelectionChanged", (e: IDataGridSelectionChangedEvent) => {
            this._selectionChanged(e);
        });
    }

    protected async _attributeChanged(_obj: OWObject, attrName: string): Promise<void> {
        if (this._conditionParamAttrs && this._conditionParamAttrs.findIndex(p => StringUtils.compareCaseInsensitive(p, attrName)) !== -1)
            this._loadData();
    }

    private async _loadData(): Promise<void> {
        await this._dataSource.loadNewData();
    }

    private _selectionChanged(evt: IDataGridSelectionChangedEvent): void {
        if (!(evt.target instanceof CheckedDataRow))
            return;

        const row = evt.target;
        if (row.isDisabled) {
            return;
        }

        const id = row.dataKey;

        this.selectionChanged.trigger(this, { id: id, value: row.isSelected });
    }
}
